import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  text?: string;
};

function ArrowValueIcon({ text }: Props) {
  const { t } = useTranslation();
  return (
    <div className="tw-relative">
      <div className="tw-absolute tw-m-auto tw-left-0 tw-right-0 tw-top-4 tw-text-center tw-text-gray-400 tw-text-sm tw-font-semibold tw-font-['Lexend'] tw-leading-tight">
        {text ? text : t("MacBotCreateVariableForm/key6")}
      </div>

      <svg
        className="xl:tw-w-[500px] tw-w-full"
        height="44"
        viewBox="0 0 556 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="556" height="28" rx="6" fill="#E5E7EB" />
        <path d="M8 28H548L278 44L8 28Z" fill="#E5E7EB" />
      </svg>
    </div>
  );
}

export default ArrowValueIcon;
